import { NODE_TYPES } from '@services/conditionEngine/constants';
import evaluatorRegistry from '@services/conditionEngine/evaluators/registry';

function multiConstantEvaluator(node) {
  return node.values;
}

evaluatorRegistry.registerEvaluatorForNodeType(NODE_TYPES.MULTI_CONSTANT, multiConstantEvaluator);
export default multiConstantEvaluator;
